import React, {
  useState,
  useContext,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import { Link, useLocation } from "react-router-dom";
import ic_color from "../../../assets/images/ic_color.svg";
import close_modal_dark from "../../../assets/images/close_modal_dark.svg";

import Logo from '../../../assets/images/wifi-attendance.svg'
import ic_view from "../../../assets/images/ic_view.svg";
import image_prf from "../../../assets/images/image_prf.svg";
import ic_search from "../../../assets/images/ic_search.svg";
import ic_search_dark from "../../../assets/images/ic_search_dark.svg";
import ic_bars_dot_dark from "../../../assets/images/ic_bars_dot_dark.svg";

import ic_bars_dot from "../../../assets/images/ic_bars_dot.svg";
// import Logo from "../../assets/images/Logo.svg";

import img_logo_bottom from "../../../assets/images/img_logo_bottom.png";
import img_logo_left from "../../../assets/images/img_logo_left.png";
import img_logo_right from "../../../assets/images/img_logo_right.png";
import img_logo_top from "../../../assets/images/img_logo_top.png";
import img_custom from "../../../assets/images/img_custom.png";
import ic_zoom from "../../../assets/images/ic_zoom.svg";
import Dropdown from "react-bootstrap/Dropdown";
import Up_arrow_white from "../../../assets/images/Up_arrow_white.svg";
import { Button, Modal } from "react-bootstrap";
import InvoiceTemplate_1 from "./TemplateLogoLeft";
import InvoiceTemplate_2 from "./TemplateLogoRight";
import InvoiceTemplate_3 from "./TemplateLogoTop";
import InvoiceTemplate_4 from "./TemplateLogoBottom";
import InvoiceCustomTemplet from "./InvoiceCustomTemplet";
import TemplateLogoBottom from "./TemplateLogoBottom";
import TemplateLogoTop from "./TemplateLogoTop";
import TemplateLogoRight from "./TemplateLogoRight";
import TemplateLogoLeft from "./TemplateLogoLeft";
import Carousel from "react-bootstrap/Carousel";
import { AppContext } from "../../../context/AppContext";
import { exportComponentAsJPEG } from "react-component-export-image";
import { useReactToPrint } from "react-to-print";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import {
  PostCallWithAuthToken,
  PostCallWithErrorResponse,
  simpleGetCall,
  simpleGetCallWithToken,
} from "../../../api/ApiServices";
import ApiConfig from "../../../api/ApiConfig";
import Axe from "../../../assets/images/x.svg";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import close_modal from "../../../assets/images/close_modal.svg";
import { displayDateFormat, isEmptyObject } from "../../../common";
import Moment from "react-moment";
import { ToWords } from "to-words";
import Loader from "../../Loader";
import { debounce } from "lodash";
// import { notifyError } from "../../sharedComponent/toaster/notify";
import SalesServiceForm from "./SalesServiceForm";
import BootstrapSpinner from "../../../sharedComponent/BootstrapSpinner";
import QRCode from "react-qr-code";

const SalesServices = () => {
  // GETTING SALES SERVICE INVOICE DATA
  const location = useLocation();

  const invoiceEditData = location?.state?.invoiceData;
  const action = location?.state?.action;
  const [invoiceAction, setInvoiceAction] = useState(action);
  let [showPreviewModal, setShowPreviewModal] = useState(false);
  // GETTING SALES SERVICE INVOICE DATA

  const {
    sidebar,
    setSidebar,
    backdrop,
    setbackdrop,
    profile,
    setprofile,
    temp,
    settemp,
    hideCopy,
    setHideCopy,
    formFormat,
    setFormFormat,
    Dark,
    userData,
    units,
    logo,
    setProductNameWidth,
    hideBothSide,
    appsetting,

    setHideBothSide,
    company_details
  } = useContext(AppContext);

  const appSettings = JSON.parse(localStorage.getItem("appSettings"))
    ? JSON.parse(localStorage.getItem("appSettings"))
    : {};

  const container = React.useRef(null);
  const pdfExportComponent = React.useRef(null);

  const exportPDFWithComponent = () => {
    if (pdfExportComponent.current) {
      pdfExportComponent.current.save();
    }
  };
  const [loading, setLoading] = useState(false);
  const [printButton, setPrintButton] = useState(true);
  const [pdfCheck, setpdfCheck] = useState(false);
  const [jpegCheck, setJpegCheck] = useState(false);
  const [printModal, setPrintModal] = useState(false);
  const [typeOfPrint, setTypeOfPrint] = useState([]);
  const [newInvoice, setNewInvoice] = useState(0);
  const [previewLoader, setPreviewLoader] = useState(false);
  const [previewSubmittedInvoiceData, setPreviewSubmittedInvoiceData] =
    useState({});
  console.log("previewSubmittedInvoiceData", previewSubmittedInvoiceData);
  const [invoiceNo, setInvoiceNo] = useState("");
  var commaNumber = require("comma-number");

  const toWords = new ToWords();

  // PLACE OF SUPPLY STATES
  const [states, setStates] = useState([]);

  const [previewTaxInvoiceData, setPreviewTaxInvoiceData] = useState({});
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [CopypreviewTaxInvoiceData, setCopyPreviewTaxInvoiceData] = useState(
    {}
  );
  const [customerInvoices, setCustomerInvoice] = useState([]);
  const amountInWords = toWords.convert(
    previewTaxInvoiceData.totalAmount ? previewTaxInvoiceData.totalAmount : 0,
    {
      currency: true,
    }
  );

  // View, Print and Export Options
  const printAction = () => {
    // notifyError("Please submit the form first");
  };

  // RecievedInvoiceIdFromChild
  const reciveInvoiceId = (id) => {
    setSelectedInvoiceId(id);
  };

  const handlePreviewFormat = () => {
    if (selectedInvoiceId) {
      getTaxInvoiceData();
      setIsView(true);
    }
  };

  const handlePrint = useReactToPrint({
    contentRef: container
  });

  // Get Invoice Tax Data Api se
  const getTaxInvoiceData = () => {
    simpleGetCallWithToken(
      ApiConfig.GET_SALES_INVOICE_TAX_DATA + `/${selectedInvoiceId}`
    )
      .then((res) => {
        // console.log(res);
        setPreviewTaxInvoiceData(res.data);
      })
      .catch((err) => console.log(err));
  };

  // Get Invoice Data

  // state of View Button
  let [isView, setIsView] = useState(false);
  let [isView1, setIsView1] = useState(false);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [Print, setPrint] = useState(false);

  const [selectedListInvoiceId, setSelectedListInvoiceId] = useState(null);

  const [discountVal, setDiscountVal] = useState(JSON.parse(localStorage.getItem("appSettings")) || {});
  useEffect(() => {
    const storedValue = JSON.parse(localStorage.getItem("appSettings"));
    if (storedValue) {
      setDiscountVal(storedValue);
    }
  }, []);

  const getInvoiceData = (id) => {
    setPreviewLoader(true);
    simpleGetCallWithToken(ApiConfig.GET_SALES_INVOICE_TAX_DATA + `/${id}`)
      .then((res) => {
        if (res.success === true) {
          if (res.data !== null) {
            setPreviewTaxInvoiceData(res.data);
            setPreviewLoader(false);
          } else {
            setPreviewLoader(true);
            console.log("error response", res);
          }
        } else {
          console.log("error response", res);
          setPreviewLoader(true);
        }
      })
      .catch((err) => console.log(err));
  };
  const getPreviewData = (invoiceId) => {
    simpleGetCallWithToken(ApiConfig.EINVOICE_PREVIEW + `/${invoiceId}`)
      .then((res) => {
        console.log(res.data);
        if (res.success == true) {
          setPreviewSubmittedInvoiceData(res.data);
          setShowPreviewModal(true)
        }
      })
      .catch((err) => console.log(err));
  };
  const getCopyTaxInvoiceData = (id) => {
    simpleGetCallWithToken(ApiConfig.GET_SALES_INVOICE_TAX_DATA + `/${id}`)
      .then((res) => {
        console.log(res);
        setCopyPreviewTaxInvoiceData(res.data);
        setInvoiceAction("submitInvoice");
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getCustomerInvoices("");
  }, []);

  const [upperCase, setUpperCase] = useState("");

  const handleInvoiceSearch = useCallback(
    debounce((e) => {
      getCustomerInvoices(e.target.value.toUpperCase());
    }, 1000),
    []
  );

  // Search API for Customer Invoices
  const getCustomerInvoices = (gstNo) => {
    setLoading(true);
    simpleGetCallWithToken(
      ApiConfig.GET_CUSTOMER_INVOICES + `?searchtxt=${gstNo}&invoicetype=Sales - Service`
    )
      .then((res) => {
        if (res.data !== null || res.data.length !== 0) {
          setCustomerInvoice(res.data.reverse());
          setLoading(false);
        }
      })
      .catch((err) => console.log(err));
  };

  const getPageMargins = () => {
    return `@page { margin: ${"20px"} ${"20px"} ${"20px"} ${"20px"} !important; } 
    @media print {
      .page-break {
        display: block;
        page-break-after: always;
      }
    }
    } `;
  };

  const isStateSame =
    previewTaxInvoiceData?.suppGSTNo?.substring(0, 2) ===
      previewTaxInvoiceData?.placeOfSupply?.split("-")[1]
      ? true
      : previewTaxInvoiceData?.placeOfSupply === ""
        ? true
        : false;

  // const [hideBothSide, setHideBothSide] = useState({
  //   lg: '8',
  //   displayBlock: ''
  // })

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.altKey && event.key === "h") {
        setHideBothSide({
          lg: "12",
          displayBlock: "none",
        });
        setProductNameWidth(true);
        setSidebar(false);
      } else if (event.ctrlKey && event.altKey && event.key === "s") {
        setHideBothSide({
          lg: "8",
          displayBlock: "",
        });
        setProductNameWidth(false);
        setSidebar(true);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const [loader, setLoader] = useState(false);
  // Invoice Submit to Government Portal
  const postInvoiceGovernment = async (invoiceId) => {
    try {
      setLoader(true);
      const res = await PostCallWithAuthToken(
        ApiConfig.EINVOICE_POST_GOV_PORTAL + `/${invoiceId}`
      );
      if (res.error) {
        console.log("Error response", res);
      }
      //else if (res.json.data.status === "0") {
      //   notifyError(res.json.data.errorResponse[0].errorInfo);
      //   setIsView(false);

      // } else {
      //   // setPreviewSubmittedInvoiceData(res.json.data);
      //   notify(res.json.message);
      //   setIsView(false);
      // }

      else if (res.json?.data?.status === "0") {
        // notifyError(res.json.data.errorResponse[0].errorInfo);
        setIsView(false);
      }
      else if (res.json?.success === false) {
        // notifyError(res.json.message);
      } else {
        // setPreviewSubmittedInvoiceData(res.json.data);
        // notify(res.json?.message)
        setIsView(false);
        getInvoiceData(invoiceId)
        getPreviewData(invoiceId)

      }
    } catch (error) {
      console.log("Catch Erorr response,", error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <main
        className={sidebar ? "SalesGoods-main" : "cx-active SalesGoods-main"}
        id="cx-main"
      >
        <div id="services-main">
          <section className="cx-inneer-header">
            <div className="main-inner">
              <div className="left">
                <label htmlFor="">
                  Services Invoice
                  {/* <img src={down_arrow} alt="" /> */}
                </label>
              </div>
              <div className="right">
                <Link to="#">
                  <button
                    onClick={() => {
                      setNewInvoice(newInvoice + 1);
                      setSelectedInvoiceId(null);
                      setInvoiceAction("submitInvoice");
                    }}
                  >
                    New Invoice
                  </button>
                </Link>
              </div>
            </div>
          </section>
          <section className="cx-content-section">
            <div className="row main-row">
              {/* ================ LEFT SECTION ============= */}

              <div className={`col-lg-8 left-section my-2`}>
                <div className="left-top-heder-main">
                  <div className="left">
                    <label htmlFor="">
                      INVOICE : <span>{invoiceNo}</span>
                    </label>
                  </div>
                  <div className="right icons">
                    <div className="d-flex align-items-center">
                      {/* {selectedInvoiceId ? (
                        <Link
                          to="#"
                          className="header-green-icons"
                          onClick={() => setPrint(true)}
                        >
                          <img src={ic_printer} alt="" />
                        </Link>
                      ) : (
                        <Link
                          to="#"
                          onClick={printAction}
                          className="header-green-icons"
                        >
                          <img src={ic_printer} alt="" />
                        </Link>
                      )} */}

                      <Modal
                        show={Print}
                        onHide={() => setPrint(false)}
                        centered
                        className="print-modal-box-main"
                      >
                        <Modal.Body>
                          <div className="header-print" closeButton>
                            <div className="left">
                              <label htmlFor="">Print</label>
                            </div>
                            <div className="right">
                              <img
                                src={close_modal}
                                alt=""
                                onClick={() => setPrint(false)}
                                style={{ cursor: "pointer" }}
                              />
                            </div>
                          </div>
                          <div className="">
                            <div className="option-btns">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                name="flexRadioDefault"
                                id="flexRadioDefault11"
                                checked={
                                  typeOfPrint.length === 3 ? true : false
                                }
                                onChange={(e) =>
                                  e.target.checked
                                    ? setTypeOfPrint([
                                      "Orginal for Buyer",
                                      "Duplicate for Transporter",
                                      "Triplicate for Supplier",
                                    ])
                                    : setTypeOfPrint([])
                                }
                              />

                              <label
                                className="form-check-label"
                                for="flexRadioDefault11"
                              >
                                All
                              </label>
                            </div>
                            <div className="option-btns">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                name="flexRadioDefault"
                                id="flexRadioDefault22"
                                checked={
                                  typeOfPrint.includes("Orginal for Buyer")
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  e.target.checked
                                    ? setTypeOfPrint([
                                      ...typeOfPrint,
                                      "Orginal for Buyer",
                                    ])
                                    : setTypeOfPrint(
                                      typeOfPrint.filter(
                                        (type) => type != "Orginal for Buyer"
                                      )
                                    );
                                }}
                              />

                              <label
                                className="form-check-label"
                                for="flexRadioDefault22"
                              >
                                Orginal for Buyer
                              </label>
                            </div>
                            <div className="option-btns">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                name="flexRadioDefault"
                                id="flexRadioDefault33"
                                checked={
                                  typeOfPrint.includes(
                                    "Duplicate for Transporter"
                                  )
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  e.target.checked
                                    ? setTypeOfPrint([
                                      ...typeOfPrint,
                                      "Duplicate for Transporter",
                                    ])
                                    : setTypeOfPrint(
                                      typeOfPrint.filter(
                                        (type) =>
                                          type != "Duplicate for Transporter"
                                      )
                                    );
                                }}
                              />

                              <label
                                className="form-check-label"
                                for="flexRadioDefault33"
                              >
                                Duplicate for Transporter{" "}
                              </label>
                            </div>
                            <div className="option-btns">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                name="flexRadioDefault"
                                id="flexRadioDefault44"
                                checked={
                                  typeOfPrint.includes(
                                    "Triplicate for Supplier"
                                  )
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  e.target.checked
                                    ? setTypeOfPrint([
                                      ...typeOfPrint,
                                      "Triplicate for Supplier",
                                    ])
                                    : setTypeOfPrint(
                                      typeOfPrint.filter(
                                        (type) =>
                                          type != "Triplicate for Supplier"
                                      )
                                    );
                                }}
                              />

                              <label
                                className="form-check-label"
                                for="flexRadioDefault44"
                              >
                                Triplicate for Supplier
                              </label>
                            </div>
                          </div>
                          <div className="footer-print">
                            <Link
                              to="#"
                              className="cancelbtn text-center"
                              onClick={() => {
                                setPrint(false);
                                setTypeOfPrint([]);
                              }}
                            >
                              Cancel
                            </Link>
                            <Link
                              to="#"
                              className="savebtn text-center"
                              onClick={() => {
                                if (typeOfPrint.length === 0) {
                                  // notifyError("Please select type of print");
                                } else {
                                  setPrintModal(true);
                                  getTaxInvoiceData();
                                }
                              }}
                            >
                              Print
                            </Link>
                          </div>
                        </Modal.Body>
                      </Modal>

                      {/* <Link
                        className="header-green-icons"
                        onClick={() => {
                          if (selectedInvoiceId) {
                            setHideCopy(true);
                            setJpegCheck(false);
                            setpdfCheck(false);
                            getTaxInvoiceData();
                            setIsView(true);
                            setPrintButton(false);
                          } else {
                            notifyError("Please submit the invoice form");
                          }
                        }}
                      >
                        <img src={ic_view} alt="" />
                      </Link> */}

                      {/* PDF, WORD Export DropDown */}
                      {/* <Dropdown className="header-dropdown-main">
                        {selectedInvoiceId ? (
                          <Dropdown.Toggle
                            id="dropdown-basic"
                            className="toggleBtn"
                          >
                            <Link to="#" className="header-green-icons">
                              <img src={ic_export} alt="" />
                            </Link>
                          </Dropdown.Toggle>
                        ) : (
                          <Dropdown.Toggle
                            id="dropdown-basic"
                            className="toggleBtn"
                          >
                            <Link
                              to="#"
                              onClick={printAction}
                              className="header-green-icons"
                            >
                              <img src={ic_export} alt="" />
                            </Link>
                          </Dropdown.Toggle>
                        )}
                        {selectedInvoiceId ? (
                          <Dropdown.Menu id="dorp-shadow">
                            <img
                              src={Up_arrow_white}
                              alt=""
                              className="up-img"
                            />
                            <div className="heading">
                              <label htmlFor="">Export As</label>
                            </div>

                            <div className="option-btns">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault1"
                                onChange={(e) => {
                                  setpdfCheck({ pdfCheck: e.target.checked });
                                  handlePreviewFormat();
                                  setJpegCheck(false);
                                  setHideCopy(true);
                                }}
                              />

                              <label
                                className="form-check-label"
                                for="flexRadioDefault1"
                              >
                                PDF
                              </label>
                            </div>
                            <div className="option-btns">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault2"
                              />

                              <label
                                className="form-check-label"
                                for="flexRadioDefault2"
                              >
                                Word
                              </label>
                            </div>
                            <div className="option-btns">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault3"
                                onChange={(e) => {
                                  setJpegCheck({ jpegCheck: e.target.checked });
                                  handlePreviewFormat();
                                  setpdfCheck(false);
                                  setHideCopy(true);
                                }}
                              />

                              <label
                                className="form-check-label"
                                for="flexRadioDefault3"
                              >
                                JPEG
                              </label>
                            </div>
                          </Dropdown.Menu>
                        ) : (
                          ""
                        )}
                      </Dropdown> */}
                      {/* PDF, WORD Export DropDown */}

                      <Dropdown
                        className="header-dropdown-main"
                        id="main-template-dropDown"
                      >
                        <div
                          onClick={() => {
                            setbackdrop(!backdrop);
                            settemp(!temp);
                            setprofile(false);
                          }}
                        >
                          <Dropdown.Toggle id="dropdown-basic">
                            <div className="d-flex align-items-center">
                              <Link
                                to="#"
                                className={
                                  temp
                                    ? "Zindex2100 header-green-icons"
                                    : "header-green-icons"
                                }
                              >
                                <img src={ic_color} alt="" />
                              </Link>
                              <div className="seprator-line"></div>
                            </div>
                          </Dropdown.Toggle>
                        </div>

                        <Dropdown.Menu>
                          <div className="outer-border">
                            <img
                              src={Up_arrow_white}
                              alt=""
                              className="up-img"
                            />

                            <div className="all-templates">
                              <div className="heading">
                                <label htmlFor="">Choose Template</label>
                              </div>
                              <div>
                                <div className="templates_body-main">
                                  <div className="main-back">
                                    <input
                                      type="radio"
                                      name="temp"
                                      id="temp1"
                                      className="d-none form-check-input"
                                      value="right"
                                      onChange={(e) => {
                                        setFormFormat(e.target.value);
                                      }}
                                    />
                                    <label
                                      htmlFor="temp1"
                                      className="label-main-out d-block"
                                    >
                                      <div className="right-logo logo-back">
                                        <div className="img-right img">
                                          <img src={img_logo_right} alt="" />
                                        </div>
                                        <Link to="#" onClick={handleShow}>
                                          <img
                                            src={ic_zoom}
                                            alt=""
                                            className="zoom-img"
                                          />
                                        </Link>
                                      </div>
                                    </label>
                                    <div className="text-logo  text-center">
                                      <label htmlFor="">Right Logo</label>
                                    </div>
                                  </div>

                                  <div className="main-back" id="left-logo">
                                    <input
                                      type="radio"
                                      name="temp"
                                      id="temp2"
                                      className="d-none form-check-input"
                                      value="left"
                                      onChange={(e) => {
                                        setFormFormat(e.target.value);
                                      }}
                                    />
                                    <label
                                      htmlFor="temp2"
                                      className="label-main-out d-block"
                                    >
                                      <div className="left-logo logo-back active-template">
                                        <div className="img-left img">
                                          <img src={img_logo_left} alt="" />
                                        </div>
                                        <Link to="#" onClick={handleShow}>
                                          <img
                                            src={ic_zoom}
                                            alt=""
                                            className="zoom-img"
                                          />
                                        </Link>
                                      </div>
                                    </label>

                                    <div className="text-logo  text-center">
                                      <label htmlFor="">Left Logo</label>
                                    </div>
                                  </div>

                                  <div className="main-back">
                                    <input
                                      type="radio"
                                      name="temp"
                                      id="temp3"
                                      className="d-none form-check-input"
                                      value="center"
                                      onChange={(e) => {
                                        setFormFormat(e.target.value);
                                      }}
                                    />
                                    <label
                                      htmlFor="temp3"
                                      className="label-main-out d-block"
                                    >
                                      <div className="top-logo logo-back">
                                        <div className="img-top img">
                                          <img src={img_logo_top} alt="" />
                                        </div>
                                        <Link to="#" onClick={handleShow}>
                                          <img
                                            src={ic_zoom}
                                            alt=""
                                            className="zoom-img"
                                          />
                                        </Link>
                                      </div>
                                    </label>
                                    <div className="text-logo  text-center">
                                      <label htmlFor="">Centere Logo</label>
                                    </div>
                                  </div>

                                  <div className="main-back">
                                    <input
                                      type="radio"
                                      name="temp"
                                      id="temp4"
                                      className="d-none form-check-input"
                                      value="bottom"
                                      onChange={(e) => {
                                        setFormFormat(e.target.value);
                                      }}
                                    />
                                    <label
                                      htmlFor="temp4"
                                      className="label-main-out d-block"
                                    >
                                      <div className="bottom-logo logo-back">
                                        <div className="img-bottom img">
                                          <img src={img_logo_bottom} alt="" />
                                        </div>
                                        <Link to="#" onClick={handleShow}>
                                          <img
                                            src={ic_zoom}
                                            alt=""
                                            className="zoom-img"
                                          />
                                        </Link>
                                      </div>
                                    </label>
                                    <div className="text-logo  text-center">
                                      <label htmlFor="">Bottom Logo</label>
                                    </div>
                                  </div>

                                  <div className="main-back">
                                    <input
                                      type="radio"
                                      name="temp"
                                      id="temp5"
                                      className="d-none form-check-input"
                                    />
                                    <label
                                      htmlFor="temp5"
                                      className="label-main-out d-block"
                                    >
                                      <div className="custom logo-back">
                                        <div className="img-custom img">
                                          <img src={img_custom} alt="" />
                                        </div>
                                        <Link to="#" onClick={handleShow}>
                                          <img
                                            src={ic_zoom}
                                            alt=""
                                            className="zoom-img"
                                          />
                                        </Link>
                                      </div>
                                    </label>
                                    <div className="text-logo  text-center">
                                      <label htmlFor="">Custom</label>
                                    </div>
                                  </div>
                                </div>
                                <div className="use-btn-temp">Use It</div>
                                <div
                                  onClick={() => {
                                    setbackdrop(false);
                                    settemp(false);
                                  }}
                                >
                                  <Modal
                                    style={{ zIndex: "2200" }}
                                    show={show}
                                    onHide={handleClose}
                                    className="modal-templates"
                                    size="lg"
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered
                                  >
                                    <Modal.Body>
                                      <Carousel>
                                        <Carousel.Item>
                                          <div
                                            className="text-end"
                                            style={{ paddingRight: "25px" }}
                                          >
                                            1/5
                                          </div>
                                          <TemplateLogoRight />
                                        </Carousel.Item>
                                        <Carousel.Item>
                                          <div
                                            className="text-end"
                                            style={{ paddingRight: "25px" }}
                                          >
                                            2/5
                                          </div>

                                          <TemplateLogoLeft />
                                        </Carousel.Item>
                                        <Carousel.Item>
                                          <div
                                            className="text-end"
                                            style={{ paddingRight: "25px" }}
                                          >
                                            3/5
                                          </div>

                                          <TemplateLogoTop />
                                        </Carousel.Item>
                                        <Carousel.Item>
                                          <div
                                            className="text-end "
                                            style={{ paddingRight: "25px" }}
                                          >
                                            4/5
                                          </div>

                                          <TemplateLogoBottom />
                                        </Carousel.Item>
                                        <Carousel.Item>
                                          <div
                                            className="text-end"
                                            style={{ paddingRight: "25px" }}
                                          >
                                            5/5
                                          </div>

                                          <InvoiceCustomTemplet />
                                        </Carousel.Item>
                                      </Carousel>
                                    </Modal.Body>
                                  </Modal>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Dropdown.Menu>
                      </Dropdown>

                      <Dropdown
                        className="header-dropdown-main"
                        id="profile-dropdown-main"
                      >
                        <div
                          onClick={() => {
                            setbackdrop(!backdrop);
                            setprofile(!profile);
                            settemp(false);
                          }}
                        >
                          <Dropdown.Toggle id="dropdown-basic">
                            <Link to="#" className={"img-profile"}>
                              <img
                                src={image_prf}
                                alt=""
                                className={profile ? "Zindex2100" : ""}
                              />
                            </Link>
                          </Dropdown.Toggle>
                        </div>

                        <Dropdown.Menu>
                          <div className="outer-border">
                            <img
                              src={Up_arrow_white}
                              alt=""
                              className="up-img"
                            />
                            <div className="main-profile-info">
                              <div className="row prosnal-info">
                                <div className="left col-lg-7">
                                  <div className="name">
                                    <div className="key">
                                      <label htmlFor="">Name</label>
                                    </div>
                                    <div className="value">
                                      <label htmlFor="">Robert Doe</label>
                                    </div>
                                  </div>
                                  <div className="business">
                                    <div className="key">
                                      <label htmlFor="">
                                        Company/Business Name
                                      </label>
                                    </div>
                                    <div className="value">
                                      <label htmlFor="">
                                        Redbytes Software Pvt. Ltd.
                                      </label>
                                    </div>
                                  </div>
                                  <div className="gst-no">
                                    <div className="key">
                                      <label htmlFor="">GST NO.</label>
                                    </div>
                                    <div className="value">
                                      <label htmlFor="">27ABCDEFGHI9A</label>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-5 right">
                                  <div className="name">
                                    <div className="key">
                                      <label htmlFor="">Taxpayer Type</label>
                                    </div>
                                    <div className="value">
                                      <label htmlFor="">Regular</label>
                                    </div>
                                  </div>
                                  <div className="business">
                                    <div className="key">
                                      <label htmlFor="">
                                        Constitution of Business
                                      </label>
                                    </div>
                                    <div className="value">
                                      <label htmlFor="">Private Limited</label>
                                    </div>
                                  </div>
                                  <div className="gst-no">
                                    <div className="key">
                                      <label htmlFor="">GSTIN Status</label>
                                    </div>
                                    <div className="value">
                                      <label htmlFor="">Active</label>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="table-details">
                                <div className="heading">
                                  <label htmlFor="">Details</label>
                                </div>
                                <div className="table-main overflowxauto">
                                  <table>
                                    <tr>
                                      <td className="center-data">Sr.No</td>
                                      <td>Particular</td>
                                      <td className="center-data">
                                        HSN/SAC Code
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="center-data">1</td>
                                      <td>Accounting and Bookeeping Service</td>
                                      <td className="center-data">998822</td>
                                    </tr>
                                    <tr>
                                      <td className="center-data">2</td>
                                      <td>IT and Web Development Service</td>
                                      <td className="center-data">223355</td>
                                    </tr>
                                    <tr>
                                      <td className="center-data">3</td>
                                      <td>Car Loans and Bike Loan Service</td>
                                      <td className="center-data">564790</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>

                <SalesServiceForm
                  states={states}
                  reciveInvoiceId={reciveInvoiceId}
                  CopiedData={CopypreviewTaxInvoiceData}
                  setInvoiceNo={setInvoiceNo}
                  invoiceNo={invoiceNo}
                  newInvoice={newInvoice}
                  handleInvoiceSearch={handleInvoiceSearch}
                  getInvoiceData={getInvoiceData}
                  setIsView={setIsView}
                  setPrintButton={setPrintButton}
                  getCustomerInvoices={getCustomerInvoices}
                  invoiceEditData={invoiceEditData}
                  invoiceAction={invoiceAction}
                  setInvoiceAction={setInvoiceAction}
                  appSettings={appSettings}
                  exportPDFWithComponent={exportPDFWithComponent}
                  setpdfCheck={setpdfCheck}
                // setHideBothSide={setHideBothSide}
                />

                {/* ============================ Preview Modal ========================== */}
                <Modal
                  className="sales-home-modal purchase-view-modal"
                  size="lg"
                  show={isView}
                  onHide={() => setIsView(false)}
                  aria-labelledby="example-modal-sizes-title-lg"
                >
                  <Modal.Body>
                    {/* <div className="btnCOpyRper">
                      <Link
                        to="#"
                        className="salesCopyBtn text-white rpsCopyBtn"
                      >
                        Copy
                      </Link>
                      <Link to="#" className="closeBtn text-white" onClick={() => setIsView(false)}>
                      <img src={Axe} alt="" />
                      </Link>
                    </div> */}

                    <div className="btnCloseRper">
                      <div>
                        <Link
                          to="#"
                          className="text-white"
                          onClick={() => {
                            setIsView(false);
                            setHideCopy(false);
                            setJpegCheck(false);
                            setpdfCheck(false);
                          }}
                        >
                          {Dark === "lightMode" ? (
                            <img
                              src={close_modal}
                              alt=""
                              onClick={() => setPrint(false)}
                              style={{ cursor: "pointer" }}
                            />
                          ) : (
                            <img
                              src={close_modal_dark}
                              alt=""
                              onClick={() => setPrint(false)}
                              style={{ cursor: "pointer" }}
                            />
                          )}
                        </Link>
                      </div>
                      <div style={{ display: "flex" }}>
                        {appSettings && appSettings.isGSTApplicable && (
                          <div style={{ marginRight: "15px" }}>
                            <button
                              disabled={loader ? true : false}
                              className="salesCopyBtn text-white rpsCopyBtn"
                              type="submit"
                              style={{
                                width: "139px",
                                height: "25px",
                                textAlign: "center",
                                border: "none",
                              }}
                              onClick={(e) => {
                                postInvoiceGovernment(previewTaxInvoiceData.id);
                              }}
                            >
                              {loader ? (
                                <div
                                  className="spinner-border text-secondar"
                                  role="status"
                                  style={{
                                    width: "1rem",
                                    height: "1rem",
                                    margin: "-2 -2",
                                  }}
                                >
                                  <span className="sr-only mt-3"></span>
                                </div>
                              ) : (
                                "Generate E-Invoice"
                              )}
                              {/* Post to Gevernment Portal */}
                            </button>
                          </div>)}
                        {printButton && (
                          <div style={{ marginRight: "15px" }}>
                            <Link
                              className="salesCopyBtn text-white rpsCopyBtn"
                              onClick={() => {
                                setPrint(true);
                                getTaxInvoiceData();
                                setIsView(false);
                              }}
                            >
                              Print
                            </Link>
                          </div>
                        )}

                        {hideCopy === false ? (
                          <div>
                            <Link
                              to="#"
                              className="salesCopyBtn text-white rpsCopyBtn"
                              onClick={() => {
                                setIsView(false);
                                getCopyTaxInvoiceData(previewTaxInvoiceData.id);
                              }}
                            >
                              Copy
                            </Link>
                          </div>
                        ) : null}
                        {jpegCheck && (
                          <div>
                            <Link
                              to="#"
                              onClick={() => {
                                exportComponentAsJPEG(container);
                              }}
                              className="salesCopyBtn text-white rpsCopyBtn"
                            >
                              JPEG
                            </Link>
                          </div>
                        )}
                        {pdfCheck && (
                          <div>
                            <Link
                              to="#"
                              onClick={exportPDFWithComponent}
                              className="salesCopyBtn text-white rpsCopyBtn"
                            >
                              PDF
                            </Link>
                          </div>
                        )}
                      </div>
                    </div>
                    <div>
                      <PDFExport
                        ref={pdfExportComponent}
                        paperSize="auto"
                        margin={40}
                        fileName={`Report for ${new Date().getFullYear()}`}
                        author="KendoReact Team"
                      >
                        <div ref={container} className="main-invoice-card">
                          {previewLoader ? (
                            <div style={{ margin: "50%" }}>
                              <BootstrapSpinner />
                            </div>
                          ) : (previewTaxInvoiceData &&
                            !isEmptyObject(previewTaxInvoiceData)) > 0 ? (
                            <React.Fragment>
                              <div className="invoice-inner-main">
                                <div className="text-invoice-main">
                                  <div className="text-invoice-inner coninversereponsive">
                                    <div className="left">
                                      <div className="text-invoice-heading">
                                        <label htmlFor="">Tax Invoice</label>
                                      </div>
                                      <div className="invoice-date-number">
                                        <label htmlFor="">
                                          {previewTaxInvoiceData.invoiceNo}
                                        </label>
                                        <label htmlFor="">
                                          Date: &nbsp;
                                          <span>
                                            {displayDateFormat(
                                              appSettings.dateFormat,
                                              previewTaxInvoiceData.invoiceDate
                                            )}
                                          </span>
                                        </label>
                                        <label htmlFor="">
                                          Due Date: &nbsp;
                                          <span>
                                            {displayDateFormat(
                                              appSettings.dateFormat,
                                              previewTaxInvoiceData.dueDate
                                            )}
                                          </span>
                                        </label>
                                      </div>
                                    </div>

                                    <div className="right">
                                      <img
                                        src={
                                          userData?.CompanyLogo
                                        }
                                        onError={(e) => e.target.src = Logo}
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="name-details-main">
                                  <div className="name-details-inner row">
                                    <div className="col-lg-7 left p-0">
                                      <div className="name">
                                        <label htmlFor="">
                                          {previewTaxInvoiceData.suppName}
                                        </label>
                                      </div>
                                      <div className="address">
                                        <div>
                                          <label htmlFor="" id="address">
                                            {previewTaxInvoiceData.suppAddr}
                                          </label>
                                        </div>
                                        <div>
                                          <label htmlFor="" className="contact">
                                            Email Id :
                                            <span>
                                              {" "}
                                              {previewTaxInvoiceData.suppEmail}
                                            </span>
                                          </label>
                                        </div>
                                        <div>
                                          <label htmlFor="" className="contact">
                                            Contact No:
                                            <span>
                                              {" "}
                                              {
                                                previewTaxInvoiceData.suppContactNo
                                              }
                                            </span>
                                          </label>
                                        </div>
                                        {appSettings && appSettings.isGSTApplicable && (
                                          <div>
                                            <label htmlFor="" className="gst-no">
                                              GST No. :{" "}
                                              <span>
                                                {" "}
                                                {previewTaxInvoiceData.suppGSTNo}
                                              </span>
                                            </label>
                                          </div>)}
                                        <div>
                                          <label htmlFor="" className="pan-no">
                                            PAN No. :{" "}
                                            <span>
                                              {previewTaxInvoiceData.suppPANNo}
                                            </span>
                                          </label>
                                        </div>
                                        {previewTaxInvoiceData?.poNo && (
                                          <div>
                                            <label
                                              htmlFor=""
                                              className="pan-no"
                                            >
                                              P.O No. :{" "}
                                              <span>
                                                {previewTaxInvoiceData?.poNo}
                                              </span>
                                            </label>
                                          </div>
                                        )}
                                        {previewTaxInvoiceData?.poDate && (
                                          <div>
                                            <label
                                              htmlFor=""
                                              className="pan-no"
                                            >
                                              PO Date :{" "}
                                              <span>
                                                {displayDateFormat(
                                                  appSettings.dateFormat,
                                                  previewTaxInvoiceData?.poDate
                                                )}
                                              </span>
                                            </label>
                                          </div>
                                        )}

                                        {/* <div>
                                          <label htmlFor="" className="pan-no">
                                            E-way Bill No. :{" "}
                                            <span>
                                              {previewTaxInvoiceData.ewayBillNo}
                                            </span>
                                          </label>
                                        </div> */}
                                      </div>
                                    </div>
                                    <div className="col-lg-5 right p-0">
                                      <div className="place-heading">
                                        <label htmlFor="">
                                          Place of Supply:
                                        </label>
                                      </div>
                                      <div className="place">
                                        <label htmlFor="">
                                          {previewTaxInvoiceData.placeOfSupply}
                                        </label>
                                      </div>

                                      <div className="place-heading">
                                        <label htmlFor="">
                                          Mode of Payment:
                                        </label>
                                      </div>
                                      <div className="place">
                                        {/* <label htmlFor="">Cash/Cheque :</label>{" "} */}
                                        <span>
                                          {previewTaxInvoiceData.modeOfPay}
                                        </span>
                                        <br />
                                        {previewTaxInvoiceData.modeOfPay ===
                                          "Cheque" && (
                                            <>
                                              <label htmlFor="">
                                                Cheque No. :{" "}
                                                <span>
                                                  {previewTaxInvoiceData.chequeNo}
                                                </span>
                                              </label>
                                              <br />
                                              <label htmlFor="">
                                                Bank Name :{" "}
                                                <span>
                                                  {previewTaxInvoiceData.bankName}
                                                </span>
                                              </label>
                                            </>
                                          )}
                                      </div>
                                      {previewTaxInvoiceData.modeOfTransport && (
                                        <>
                                          <div className="place-heading ">
                                            <label htmlFor="">
                                              Mode Of Transport :
                                            </label>
                                          </div>
                                          <div className="place">
                                            <label htmlFor="">
                                              {
                                                previewTaxInvoiceData.modeOfTransport
                                              }
                                            </label>
                                          </div>
                                        </>
                                      )}

                                      {previewTaxInvoiceData.modeOfTransport ===
                                        "By Road" && (
                                          <>
                                            <div className="place-heading ">
                                              <label htmlFor="">
                                                Vehicle No.
                                              </label>
                                            </div>
                                            <div className="place">
                                              <label htmlFor="">
                                                {
                                                  previewTaxInvoiceData.vehicleNumber
                                                }
                                              </label>
                                            </div>
                                          </>
                                        )}
                                      {previewTaxInvoiceData?.lutBondNo && (
                                        <>
                                          <div className="place-heading ">
                                            <label htmlFor="">
                                              LUT Bond No
                                            </label>
                                          </div>
                                          <div className="place">
                                            <label htmlFor="">
                                              {previewTaxInvoiceData?.lutBondNo}
                                            </label>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <div className="name-details-main" id="info">
                                  <div className="name-details-inner row">
                                    <div className="col-lg-7 left p-0">
                                      <div className="name">
                                        <label htmlFor="" id="small-heading">
                                          Bill To,
                                        </label>

                                        <br />
                                      </div>
                                      <div className="address">
                                        <div>
                                          <label htmlFor="">
                                            {previewTaxInvoiceData.custName}
                                          </label>
                                        </div>
                                        <div>
                                          <label htmlFor="" id="address">
                                            {/* H. No. 6-AB, <br /> Bistol tower, Azad
                                        Nagar <br /> New Delhi, India */}
                                            {previewTaxInvoiceData.billAddr}
                                          </label>
                                        </div>
                                        <div>
                                          <label htmlFor="" className="contact">
                                            Email Id :
                                            <span>
                                              {" "}
                                              {previewTaxInvoiceData.billEmail}
                                            </span>
                                          </label>
                                        </div>
                                        <div>
                                          <label htmlFor="" className="contact">
                                            Contact No:
                                            <span>
                                              {" "}
                                              {
                                                previewTaxInvoiceData.billContactNo
                                              }
                                            </span>
                                          </label>
                                        </div>
                                        {appSettings && appSettings.isGSTApplicable && (
                                          <div>
                                            <label htmlFor="" className="gst-no">
                                              GST:{" "}
                                              <span>
                                                {previewTaxInvoiceData.billGSTNo}{" "}
                                              </span>
                                            </label>
                                          </div>)}
                                        {previewTaxInvoiceData.billState && (
                                          <div>
                                            <label
                                              htmlFor=""
                                              className="gst-no"
                                            >
                                              State :{" "}
                                              <span>
                                                {
                                                  previewTaxInvoiceData.billState
                                                }{" "}
                                              </span>
                                            </label>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    {previewTaxInvoiceData?.shipCustName ? (
                                      <div className="col-lg-5 right p-0">
                                        <div className="name">
                                          <label htmlFor="" id="small-heading">
                                            Ship To,{" "}
                                          </label>

                                          <br />
                                        </div>
                                        <div className="address">
                                          <div>
                                            <label htmlFor="">
                                              {
                                                previewTaxInvoiceData.shipCustName
                                              }
                                            </label>
                                          </div>
                                          <div>
                                            <label htmlFor="" id="address">
                                              {/* H. No. 6-AB, <br /> Bistol tower, Azad
                                        Nagar <br /> New Delhi, India */}
                                              {previewTaxInvoiceData.shipAddr}
                                            </label>
                                          </div>
                                          <div>
                                            <label
                                              htmlFor=""
                                              className="contact"
                                            >
                                              Contact No:
                                              <span>
                                                {" "}
                                                {
                                                  previewTaxInvoiceData.shipContactNo
                                                }
                                              </span>
                                            </label>
                                          </div>
                                          {appSettings && appSettings.isGSTApplicable && (
                                            <div>
                                              <label
                                                htmlFor=""
                                                className="gst-no"
                                              >
                                                GST:{" "}
                                                <span>
                                                  {
                                                    previewTaxInvoiceData.shipGSTNo
                                                  }{" "}
                                                </span>
                                              </label>
                                            </div>)}
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                                <div
                                  className="detail-table-main"
                                  id="modal-in-tab"
                                >
                                  <table>
                                    <thead>
                                      <tr className="heading-row">
                                        <td>#</td>
                                        <td>Product Name/Service Name</td>
                                        <td>HSN/SAC</td>
                                        <td>Quantity</td>
                                        <td>Rate</td>
                                        <td>Unit</td>
                                        <td>
                                          Disc.{" "}
                                          <span>
                                            {discountVal.discType === "Amount"
                                              ? `(₹)`
                                              : `(%)`}
                                          </span>
                                        </td>
                                        <td>Amount</td>
                                        {appSettings && appSettings?.isGSTApplicable &&
                                          (isStateSame) ? (
                                          <>
                                            <td colSpan="2">CGST</td>
                                            <td colSpan="2">SGST</td>
                                          </>
                                        ) : (

                                          <>
                                            {appSettings && appSettings?.isGSTApplicable && (
                                              <td colSpan="2">IGST</td>
                                            )}
                                          </>
                                        )}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {previewTaxInvoiceData.invoiceDetails
                                        .length > 0 &&
                                        previewTaxInvoiceData.invoiceDetails.map(
                                          (invDetails) => {
                                            let unit =
                                              units &&
                                              units.filter((item) => {
                                                return (
                                                  item.id === invDetails.unitId
                                                );
                                              })[0]?.unit;

                                            return (
                                              <tr key={invDetails.id}>
                                                <td>{invDetails.id}</td>
                                                <td>
                                                  {invDetails.productName}
                                                </td>
                                                <td>{invDetails.hsnCode}</td>
                                                <td>{invDetails.qty}</td>
                                                <td>{invDetails.rate}</td>
                                                <td> {invDetails.unit}</td>
                                                <td>
                                                  {invDetails.discPer}
                                                  {appSettings?.discType ===
                                                    "Amount"
                                                    ? ""
                                                    : "%"}
                                                </td>
                                                <td>{invDetails.discAmount}</td>
                                                {appSettings && appSettings.isGSTApplicable && (
                                                  isStateSame) ? (
                                                  <>
                                                    {appSettings && appSettings.isGSTApplicable && (

                                                      <td>{invDetails.cgst}%</td>)}
                                                    {appSettings && appSettings.isGSTApplicable && (

                                                      <td>
                                                        {" "}
                                                        {invDetails.cgstAmount}
                                                      </td>)}
                                                    {appSettings && appSettings.isGSTApplicable && (

                                                      <td>{invDetails.sgst}%</td>)}
                                                    {appSettings && appSettings.isGSTApplicable && (

                                                      <td>
                                                        {" "}
                                                        {invDetails.sgstAmount}
                                                      </td>)}
                                                  </>
                                                ) : (
                                                  <>

                                                    {appSettings && appSettings.isGSTApplicable && (
                                                      <td>{invDetails.igst}%</td>)}
                                                    {appSettings && appSettings.isGSTApplicable && (
                                                      <td>
                                                        {" "}
                                                        {invDetails.igstAmount}
                                                      </td>)}
                                                  </>
                                                )}
                                              </tr>
                                            );
                                          }
                                        )}
                                    </tbody>
                                  </table>
                                </div>
                                <div className="sub-total-section">
                                  <div className="bank-details">
                                    {previewTaxInvoiceData?.bankDetails && (
                                      <label htmlFor="">Bank Details :</label>
                                    )}
                                    {previewTaxInvoiceData?.bankDetails &&
                                      previewTaxInvoiceData?.bankDetails
                                        .split("\r\n")
                                        .map((str, i) => {
                                          return (
                                            <div
                                              key={i + "bankDetails"}
                                              className="bank-sub"
                                            >
                                              <label htmlFor="">
                                                {str && str}
                                              </label>
                                            </div>
                                          );
                                        })}
                                  </div>
                                  <div className="right-section">
                                    <div className="left">
                                      <div className="text-sub">
                                        <label htmlFor="">Sub Total</label>
                                      </div>
                                      {appSettings && appSettings.isGSTApplicable &&
                                        (!isStateSame || previewTaxInvoiceData?.isSEZEnabled)
                                        ?
                                        (
                                          <div className="text-sub">
                                            <label htmlFor="">IGST</label>
                                          </div>
                                        ) : (
                                          <>
                                            {appSettings && appSettings.isGSTApplicable && (
                                              <div className="text-sub">
                                                <label htmlFor="">CGST</label>
                                              </div>)}
                                            {appSettings && appSettings.isGSTApplicable && (
                                              <div className="text-sub">
                                                <label htmlFor="">SGST</label>
                                              </div>)}
                                          </>
                                        )}
                                      {appSettings &&
                                        appSettings?.isRoundOff && (
                                          <div className="text-sub">
                                            <label htmlFor="">Round off</label>
                                          </div>
                                        )}
                                    </div>
                                    <div className="right">
                                      <div className="sub-total">
                                        <label htmlFor="">
                                          Rs.{" "}
                                          {previewTaxInvoiceData.subTotal?.toFixed(
                                            2
                                          )}
                                        </label>
                                      </div>
                                      {appSettings &&
                                        appSettings.isGSTApplicable &&
                                        (isStateSame) ? (
                                        <>
                                          <div className="sub-total">
                                            <label htmlFor="">
                                              Rs.{" "}
                                              {previewTaxInvoiceData.cgstAmount.toFixed(
                                                2
                                              )}
                                            </label>
                                          </div>
                                          <div className="sub-total">
                                            <label htmlFor="">
                                              Rs.{" "}
                                              {previewTaxInvoiceData.sgstAmount.toFixed(
                                                2
                                              )}
                                            </label>
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          {appSettings &&
                                            appSettings.isGSTApplicable && (
                                              <div className="sub-total">
                                                <label htmlFor="">
                                                  Rs.{" "}
                                                  {previewTaxInvoiceData.igstAmount.toFixed(
                                                    2
                                                  )}
                                                </label>
                                              </div>)}
                                        </>
                                      )}
                                      {appSettings &&
                                        appSettings?.isRoundOff && (
                                          <div className="sub-total">
                                            <label htmlFor="">
                                              Rs.{" "}
                                              {previewTaxInvoiceData.roundOff.toFixed(
                                                2
                                              ) || "0.00"}
                                            </label>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                </div>
                                <div className="mainsub-total"></div>
                                <div className="total-amt-main">
                                  <div
                                    className="total-amount-section"
                                    id="sub-total-section"
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        marginRight: "250px",
                                        alignItems: "left",
                                        fontSize: "12px"
                                      }}
                                    >
                                      <label htmlFor=""> <b>Payments Terms : </b>
                                      </label>
                                      <label htmlFor="">
                                        &nbsp;
                                        {previewTaxInvoiceData?.paymentTerms}
                                      </label>
                                    </div>
                                    <div className="left">
                                      <div className="text-sub">
                                        <label htmlFor="">Total Amount</label>
                                      </div>
                                    </div>
                                    <div className="right">
                                      <div className="sub-total">
                                        <label htmlFor="">
                                          Rs.{" "}
                                          {commaNumber(
                                            Math.round(
                                              previewTaxInvoiceData.totalAmount
                                            ).toFixed(2)
                                          )}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="in-word">
                                    <label htmlFor="">{amountInWords}</label>
                                  </div>
                                </div>
                                <div className="line-total"></div>
                                <div className="disc-sign-main row">
                                  {/* <div className="col-lg-4 left ps-0">
                                    <div className="description">
                                      <textarea
                                        className="form-control"
                                        id="exampleFormControlTextarea1"
                                        rows="3"
                                        placeholder="Declaration"
                                      ></textarea>
                                    </div>
                                  </div> */}
                                  <div className="col-lg-7 left ps-0">
                                    <div className="Terms-of-Services">
                                      <div className="heading-TS">
                                        <label htmlFor="">
                                          Terms of Services
                                        </label>
                                      </div>
                                      <div className="term-conditions">
                                        {logo?.terms ? logo.terms : ""}
                                      </div>
                                      {/* <ul>
                                        <li>Terms of Services</li>
                                        <li>Terms of Services</li>
                                        <li>Terms of Services</li>
                                        <li>Terms of Services</li>
                                        <li>Terms of Services</li>
                                      </ul> */}
                                    </div>
                                  </div>
                                  <div className="col-lg-5 right pe-0 ps-0">
                                    <div className="upload">
                                      {Dark === "lightMode" ? (
                                        <img
                                          src={
                                            logo?.signtureLogo
                                              ? logo?.signtureLogo
                                              : ""
                                          }
                                          alt=""
                                        />
                                      ) : (
                                        <img
                                          src={
                                            logo?.signtureLogo
                                              ? logo?.signtureLogo
                                              : ""
                                          }
                                          alt=""
                                        />
                                      )}{" "}
                                      {/* <br />
                                      <label htmlFor="" className="text-up">
                                        Upload your signature
                                      </label>
                                    */}
                                      <br />
                                      <label htmlFor="" className="text-auth">
                                        Authorized Signature
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </React.Fragment>
                          ) : null}
                        </div>
                      </PDFExport>
                    </div>
                  </Modal.Body>
                </Modal>

                {/* new preview modal */}
                <Modal
                  className="sales-home-modal purchase-view-modal"
                  size="lg"
                  show={showPreviewModal}
                  onHide={() => setShowPreviewModal(false)}
                  aria-labelledby="example-modal-sizes-title-lg"
                >
                  <Modal.Body>
                    <div
                      className="btnCloseRper"
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <Link to="#" className="text-white">
                          {Dark === "lightMode" ? (
                            <img
                              src={close_modal}
                              alt=""
                              style={{ cursor: "pointer" }}
                              onClick={() => setShowPreviewModal(false)}
                            />
                          ) : (
                            <img
                              src={close_modal_dark}
                              alt=""
                              style={{ cursor: "pointer" }}
                              onClick={() => setShowPreviewModal(false)}
                            />
                          )}
                        </Link>
                      </div>
                    </div>

                    <div>
                      <Link
                        to="#"
                        onClick={() => {
                          setPrintModal(true);
                          setShowPreviewModal(false);
                        }}
                        className="salesCopyBtn text-white rpsCopyBtn"
                      >
                        Print
                      </Link>
                    </div>

                    <div>
                      {(previewTaxInvoiceData &&
                        !isEmptyObject(previewTaxInvoiceData)) > 0 ? (
                        <div
                          // ref={container}
                          className="main-invoice-card dont-print-that"
                        >
                          <div className="invoice-inner-main">
                            <div className="text-invoice-main">
                              <div className="text-invoice-inner coninversereponsive">
                                <div className="left">
                                  <div className="text-invoice-heading">
                                    <label htmlFor="">E-Invoice</label>
                                  </div>
                                  <div className="invoice-date-number">
                                    <label htmlFor="">
                                      {previewTaxInvoiceData.invoiceNo}
                                    </label>
                                    <label htmlFor="">
                                      Date &nbsp;: &nbsp;
                                      <span>
                                        <Moment format="DD/MM/YYYY">
                                          {previewTaxInvoiceData.invoiceDate}
                                        </Moment>
                                      </span>
                                    </label>
                                    <label htmlFor="">
                                      Due Date &nbsp;: &nbsp;
                                      <span>
                                        <Moment format="DD/MM/YYYY">
                                          {previewTaxInvoiceData.dueDate}
                                        </Moment>
                                      </span>
                                    </label>
                                    <label htmlFor="">
                                      Place of Supply &nbsp;: &nbsp;
                                      <span>
                                        {previewTaxInvoiceData.placeOfSupply}
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                {/* <div className="right">
                        <img src={Logo} alt="" />
                      </div> */}
                              </div>
                            </div>

                            <div className="name-details-main" id="info">
                              <div className="name-details-inner row">
                                {/* Bill To */}
                                <div className="col-lg-7 left p-0">
                                  <div className="name">
                                    <label htmlFor="" id="small-heading">
                                      Bill To
                                    </label>

                                    <br />
                                  </div>
                                  <div className="address">
                                    <div>
                                      <label htmlFor="">
                                        {previewTaxInvoiceData.custName}
                                      </label>
                                    </div>
                                    <div>
                                      <label htmlFor="" id="address">
                                        {/* H. No. 6-AB, <br /> Bistol tower, Azad
                                        Nagar <br /> New Delhi, India */}
                                        {previewTaxInvoiceData.billAddr}
                                      </label>
                                    </div>
                                    <div>
                                      <label htmlFor="" className="contact">
                                        Contact No:
                                        <span>
                                          {" "}
                                          {previewTaxInvoiceData.billContactNo}
                                        </span>
                                      </label>
                                    </div>
                                    <div>
                                      <label htmlFor="" className="gst-no">
                                        GST:{" "}
                                        <span>
                                          {previewTaxInvoiceData.billGSTNo}
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                {/* Ship To */}
                                <div className="col-lg-5 right p-0">
                                  <div className="name">
                                    <label htmlFor="" id="small-heading">
                                      Bill From{" "}
                                    </label>

                                    <br />
                                  </div>
                                  <div className="address">
                                    <div>
                                      <label htmlFor="">
                                        {previewTaxInvoiceData.suppName}
                                      </label>
                                    </div>
                                    <div>
                                      <label htmlFor="" id="address">
                                        {/* H. No. 6-AB, <br /> Bistol tower, Azad
                                        Nagar <br /> New Delhi, India */}
                                        {previewTaxInvoiceData.suppAddr}
                                      </label>
                                    </div>
                                    <div>
                                      <label htmlFor="" className="gst-no">
                                        GST:{" "}
                                        <span>
                                          {previewTaxInvoiceData.suppGSTNo}{" "}
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <hr style={{ border: "1px solid black" }}></hr>
                            <div className="name-details-main" id="info">
                              <div className="name-details-inner row">
                                <div className="col-lg-7 left p-0">
                                  <div className="address">
                                    <label htmlFor="" className="contact">
                                      IRN No:
                                      <div>
                                        <span>
                                          {" "}
                                          {previewSubmittedInvoiceData?.eInvIRN?.substring(
                                            0,
                                            32
                                          )}
                                        </span>
                                        <br />
                                        <span>
                                          {" "}
                                          {previewSubmittedInvoiceData?.eInvIRN?.substring(
                                            32
                                          )}
                                        </span>
                                      </div>
                                    </label>
                                  </div>
                                </div>
                                <div className="col-lg-5 right p-0">
                                  <div className="address">
                                    <label style={{ fontStyle: "11px" }}>
                                      QR Code:
                                    </label>{" "}
                                    <br />
                                    <QRCode
                                      size={256}
                                      style={{
                                        height: "auto",
                                        width: "160px",
                                      }}
                                      value={
                                        previewSubmittedInvoiceData?.eInvSignedQRCode
                                          ? previewSubmittedInvoiceData?.eInvSignedQRCode
                                          : ""
                                      }
                                      viewBox={`0 0 256 256`}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* =========================== Product Table =========================== */}

                            <div
                              className="detail-table-main"
                              id="modal-in-tab"
                            >
                              <table>
                                <thead>
                                  <tr className="heading-row">
                                    <td>#</td>
                                    <td>Product Name</td>
                                    <td>HSN</td>
                                    <td>Quantity</td>
                                    <td>Rate</td>
                                    {isStateSame ? (
                                      <>
                                        <td colSpan="2">CGST</td>
                                        <td colSpan="2">SGST</td>
                                      </>
                                    ) : (
                                      <td colSpan="2">IGST</td>
                                    )}
                                    <td>Amount</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  {previewTaxInvoiceData.invoiceDetails &&
                                    previewTaxInvoiceData.invoiceDetails
                                      ?.length > 0 &&
                                    previewTaxInvoiceData.invoiceDetails.map(
                                      (invDetails, index) => {
                                        return (
                                          <tr
                                            key={
                                              "previewTaxInvoiceData1" +
                                              invDetails.id
                                            }
                                          >
                                            <td>{index + 1}</td>
                                            <td>{invDetails.productName}</td>
                                            <td>{invDetails.hsnCode}</td>
                                            <td>{invDetails.qty}</td>
                                            <td>&#x20b9; {invDetails.rate}</td>

                                            {isStateSame ? (
                                              <>
                                                <td>{invDetails.cgst}%</td>
                                                <td>
                                                  Rs. {invDetails.cgstAmount}
                                                </td>
                                                <td>{invDetails.sgst}%</td>
                                                <td>
                                                  Rs. {invDetails.sgstAmount}
                                                </td>
                                              </>
                                            ) : (
                                              <>
                                                <td>{invDetails.igst}%</td>
                                                <td>
                                                  Rs. {invDetails.igstAmount}
                                                </td>
                                              </>
                                            )}

                                            <td>Rs. {invDetails.discAmount}</td>
                                          </tr>
                                        );
                                      }
                                    )}
                                </tbody>
                              </table>
                            </div>

                            <div
                              // className="sub-total-section"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginRight: "15px",
                              }}
                            >
                              {/* Signature QR code */}
                              <div className="col-lg-7">
                                <div style={{ marginLeft: "12px" }}>
                                  <label
                                    style={{
                                      fontSize: "11px",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    Signature :
                                  </label>
                                  <br />
                                  {company_details?.signtureLogo && (
                                    <img
                                      style={{ width: "90px" }}
                                      src={company_details?.signtureLogo}
                                      alt="Not found"
                                    />
                                  )}
                                </div>
                              </div>
                              <div
                                className="col-lg-5"
                                style={{
                                  display: "flex",
                                  width: "auto",
                                  // justifyContent: "space-between",
                                }}
                              >
                                <div className="sub-total-section">
                                  <div className="right-section">
                                    <div className="left">
                                      <div className="text-sub">
                                        <label htmlFor="">Sub Total</label>
                                      </div>
                                      {isStateSame ? (
                                        <>
                                          <div className="text-sub">
                                            <label htmlFor="">CGST</label>
                                          </div>
                                          <div className="text-sub">
                                            <label htmlFor="">SGST</label>
                                          </div>
                                        </>
                                      ) : (
                                        <div className="text-sub">
                                          <label htmlFor="">IGST</label>
                                        </div>
                                      )}

                                      <div className="text-sub">
                                        <label htmlFor="">Round off</label>
                                      </div>
                                    </div>
                                    <div className="right">
                                      <div className="sub-total">
                                        <label htmlFor="">
                                          Rs.{" "}
                                          {previewTaxInvoiceData.subTotal?.toFixed(
                                            2
                                          )}
                                        </label>
                                      </div>
                                      {isStateSame ? (
                                        <>
                                          <div className="sub-total">
                                            <label htmlFor="">
                                              Rs.{" "}
                                              {previewTaxInvoiceData.cgstAmount?.toFixed(
                                                2
                                              )}
                                            </label>
                                          </div>
                                          <div className="sub-total">
                                            <label htmlFor="">
                                              Rs.{" "}
                                              {previewTaxInvoiceData.sgstAmount?.toFixed(
                                                2
                                              )}
                                            </label>
                                          </div>
                                        </>
                                      ) : (
                                        <div className="sub-total">
                                          <label htmlFor="">
                                            Rs.{" "}
                                            {previewTaxInvoiceData.igstAmount?.toFixed(
                                              2
                                            )}
                                          </label>
                                        </div>
                                      )}

                                      <div className="sub-total">
                                        <label htmlFor="">
                                          Rs.{" "}
                                          {previewTaxInvoiceData?.roundOff?.toFixed(
                                            2
                                          ) || "0.00"}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="mainsub-total"></div>

                            <div className="total-amt-main">
                              <div
                                className="total-amount-section"
                                id="sub-total-section"
                              >
                                <div className="left">
                                  <div className="text-sub">
                                    <label htmlFor="">Total Amount</label>
                                  </div>
                                </div>
                                <div className="right">
                                  <div className="sub-total">
                                    <label htmlFor="">
                                      Rs.{" "}
                                      {commaNumber(
                                        Math.round(
                                          previewTaxInvoiceData.totalAmount
                                        ).toFixed(2)
                                      )}
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div className="in-word">
                                <label htmlFor="">{amountInWords}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <BootstrapSpinner />
                      )}
                    </div>
                  </Modal.Body>
                </Modal>
                {/* =================== PRINT MODAL START ======================== */}

                <Modal
                  className="sales-home-modal purchase-view-modal"
                  id="print-modal-style"
                  size="lg"
                  show={printModal}
                  onHide={() => setPrintModal(false)}
                  aria-labelledby="example-modal-sizes-title-lg"
                >
                  <Modal.Body>
                    <div className="btnCloseRper">
                      <div>
                        <Link
                          to="#"
                          className="text-white"
                          onClick={() => setIsView(false)}
                        >
                          <img
                            src={Axe}
                            alt=""
                            className="closeBtn"
                            onClick={() => setPrintModal(false)}
                          />
                        </Link>
                      </div>
                      <div>
                        <Link
                          to="#"
                          onClick={() => {
                            handlePrint();
                            setPrintModal(false);
                          }}
                          className="salesCopyBtn text-white rpsCopyBtn"
                        >
                          Print
                        </Link>
                      </div>
                    </div>

                    <div ref={container}>
                      {typeOfPrint.map((type, index) => {
                        return (
                          <div
                            key={"type" + index}
                            // style={{ visibility: index != 0 && "hidden" }}
                            className="main-invoice-card  page-break"
                          >
                            <style>{getPageMargins()}</style>
                            <div
                              className="print-copy-type text-center "
                              style={{
                                // textAlign: "center",
                                marginTop: "-10px",
                                fontSize: "10px",
                              }}
                            >
                              {type}
                            </div>
                            <div
                              className="invoice-inner-main "
                              style={{
                                border: "0.765311px solid #111111",
                                // margin: "0 15px 15px 15px",
                                // marginLeft: "15px",
                                //   marginRight:"15px",
                                // padding:"10px"
                                // margin:"15px"
                              }}
                            >
                              <div
                                className="text-invoice-main"
                                style={{
                                  borderBottom: "0.765311px solid #111111 ",
                                  // marginBottom:"0"
                                }}
                              >
                                <div className="text-invoice-inner coninversereponsive">
                                  <table style={{ width: "100%" }}>
                                    <tr>
                                      <td style={{ width: "100%" }}>
                                        <div className="left">
                                          <table>
                                            <tr>
                                              <td>
                                                <div className="text-invoice-heading">
                                                  <label htmlFor="">
                                                    Tax Invoice
                                                  </label>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div className="invoice-date-number">
                                                  <table>
                                                    <tr>
                                                      <td>
                                                        <label htmlFor="">
                                                          {
                                                            previewTaxInvoiceData.invoiceNo
                                                          }
                                                        </label>
                                                      </td>
                                                      <td>
                                                        <label htmlFor="">
                                                          Date: &nbsp;
                                                          <span>
                                                            {displayDateFormat(
                                                              appSettings.dateFormat,
                                                              previewTaxInvoiceData.invoiceDate
                                                            )}
                                                          </span>
                                                        </label>
                                                      </td>
                                                      <td>
                                                        <label htmlFor="">
                                                          Due Date: &nbsp;
                                                          <span>
                                                            {displayDateFormat(
                                                              appSettings.dateFormat,
                                                              previewTaxInvoiceData.dueDate
                                                            )}
                                                          </span>
                                                        </label>
                                                      </td>
                                                    </tr>
                                                  </table>
                                                </div>
                                              </td>
                                            </tr>
                                          </table>
                                        </div>
                                      </td>
                                      <td>
                                        {/* <div className="right">
                                          <img src={Logo} alt="" />
                                        </div> */}
                                        <div className="right">
                                          <img
                                            src={userData?.CompanyLogo}
                                            alt=""
                                            onError={(e) => e.target.src = Logo}
                                          />

                                        </div>
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                              <div
                                className="name-details-main"
                                style={{
                                  borderBottom: "0.765311px solid #111111 ",
                                  // padding: " 0 15px",
                                }}
                              >
                                <div
                                  className="name-details-inner "
                                  style={{ margin: "0" }}
                                >
                                  <div className="print-table-outer">
                                    <table style={{ width: "100%" }}>
                                      <tr>
                                        <td
                                          style={{ width: "58%" }}
                                          valign="top"
                                          className="printtable-companyName"
                                        >
                                          <div className=" left p-0">
                                            <div className="name">
                                              <label htmlFor="">
                                                {previewTaxInvoiceData.suppName}
                                              </label>
                                            </div>
                                            <div className="address">
                                              <div>
                                                <label htmlFor="" id="address">
                                                  {
                                                    previewTaxInvoiceData.suppAddr
                                                  }
                                                </label>
                                              </div>
                                              <div>
                                                <label
                                                  htmlFor=""
                                                  className="contact"
                                                  style={{ fontSize: "11px" }}
                                                >
                                                  Email Id :
                                                  <span>
                                                    {" "}
                                                    {
                                                      previewTaxInvoiceData.suppEmail
                                                    }
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label
                                                  htmlFor=""
                                                  className="contact"
                                                  style={{ fontSize: "11px" }}
                                                >
                                                  Contact No:
                                                  <span>
                                                    {" "}
                                                    {
                                                      previewTaxInvoiceData.suppContactNo
                                                    }
                                                  </span>
                                                </label>
                                              </div>
                                              {appSettings && appSettings.isGSTApplicable && (
                                                <div>
                                                  <label
                                                    htmlFor=""
                                                    className="gst-no"
                                                  >
                                                    GST No. :
                                                    <span>
                                                      {" "}
                                                      {
                                                        previewTaxInvoiceData.suppGSTNo
                                                      }
                                                    </span>
                                                  </label>
                                                </div>)}
                                              <div>
                                                <label
                                                  htmlFor=""
                                                  className="pan-no"
                                                >
                                                  PAN No. :{" "}
                                                  <span>
                                                    {
                                                      previewTaxInvoiceData.suppPANNo
                                                    }
                                                  </span>
                                                </label>
                                              </div>
                                              {previewTaxInvoiceData?.poNo && (
                                                <div>
                                                  <label
                                                    htmlFor=""
                                                    className="pan-no"
                                                  >
                                                    P.O No. :{" "}
                                                    <span>
                                                      {
                                                        previewTaxInvoiceData?.poNo
                                                      }
                                                    </span>
                                                  </label>
                                                </div>
                                              )}
                                              {previewTaxInvoiceData?.poDate && (
                                                <div>
                                                  <label
                                                    htmlFor=""
                                                    className="pan-no"
                                                  >
                                                    PO Date :{" "}
                                                    <span>
                                                      {displayDateFormat(
                                                        appSettings.dateFormat,
                                                        previewTaxInvoiceData?.poDate
                                                      )}
                                                    </span>
                                                  </label>
                                                </div>
                                              )}

                                              {/* <div>
                                                <label
                                                  htmlFor=""
                                                  className="pan-no"
                                                >
                                                  E-way Bill No. :{" "}
                                                  <span>
                                                    {
                                                      previewTaxInvoiceData.ewayBillNo
                                                    }
                                                  </span>
                                                </label>
                                              </div> */}
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <div
                                            className=" right p-0"
                                            style={{ margin: "-12px 0 0 0" }}
                                          >
                                            <div className="place-heading">
                                              <label htmlFor="">
                                                Place of Supply:
                                              </label>
                                            </div>
                                            <div className="place">
                                              <label htmlFor="">
                                                {
                                                  previewTaxInvoiceData.placeOfSupply
                                                }
                                              </label>
                                            </div>
                                            <div className="place-heading">
                                              <label htmlFor="">
                                                Mode of Payment:
                                              </label>
                                            </div>
                                            <div className="place">
                                              <div>
                                                {/* <label htmlFor=""> Cash/Cheque. </label> */}
                                                <span>
                                                  {
                                                    previewTaxInvoiceData.modeOfPay
                                                  }
                                                </span>
                                              </div>
                                              {previewTaxInvoiceData.modeOfPay ===
                                                "Cheque" && (
                                                  <>
                                                    <div>
                                                      <label htmlFor="">
                                                        Cheque No.{" "}
                                                        <span>
                                                          {
                                                            previewTaxInvoiceData.chequeNo
                                                          }
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div>
                                                      <label htmlFor="">
                                                        {
                                                          previewTaxInvoiceData.bankName
                                                        }
                                                      </label>
                                                    </div>
                                                  </>
                                                )}
                                            </div>
                                            {previewTaxInvoiceData.modeOfTransport && (
                                              <>
                                                <div className="place-heading ">
                                                  <label htmlFor="">
                                                    Mode Of Transport:
                                                  </label>
                                                </div>
                                                <div className="place">
                                                  <label htmlFor="">
                                                    {" "}
                                                    {
                                                      previewTaxInvoiceData.modeOfTransport
                                                    }
                                                  </label>
                                                </div>
                                              </>
                                            )}

                                            {previewTaxInvoiceData.modeOfTransport ===
                                              "By Road" && (
                                                <>
                                                  <div className="place-heading ">
                                                    <label htmlFor="">
                                                      Vehicle No.
                                                    </label>
                                                  </div>
                                                  <div className="place">
                                                    <label htmlFor="">
                                                      {
                                                        previewTaxInvoiceData.vehicleNumber
                                                      }
                                                    </label>
                                                  </div>
                                                </>
                                              )}

                                            {previewTaxInvoiceData?.lutBondNo && (
                                              <>
                                                <div className="place-heading ">
                                                  <label htmlFor="">
                                                    LUT Bond No
                                                  </label>
                                                </div>
                                                <div className="place">
                                                  <label htmlFor="">
                                                    {
                                                      previewTaxInvoiceData?.lutBondNo
                                                    }
                                                  </label>
                                                </div>
                                              </>
                                            )}
                                          </div>
                                        </td>
                                      </tr>
                                    </table>
                                  </div>
                                </div>
                              </div>
                              <div className="name-details-main" id="info">
                                <div className="name-details-inner  ">
                                  <div className="print-table-outer">
                                    <table
                                      className=""
                                      style={{ width: "100%" }}
                                    >
                                      <tr>
                                        <td style={{ width: "58%" }}>
                                          <div className=" left p-0">
                                            <div className="name">
                                              <label
                                                htmlFor=""
                                                id="small-heading"
                                              >
                                                Bill To,
                                              </label>

                                              <br />
                                            </div>
                                            <div className="address">
                                              <div>
                                                <label htmlFor="">
                                                  {
                                                    previewTaxInvoiceData.custName
                                                  }
                                                </label>
                                              </div>
                                              <div>
                                                <label htmlFor="" id="address">
                                                  {
                                                    previewTaxInvoiceData.billAddr
                                                  }
                                                </label>
                                              </div>
                                              <div>
                                                <label
                                                  htmlFor=""
                                                  className="contact"
                                                >
                                                  Email Id :
                                                  <span>
                                                    {" "}
                                                    {
                                                      previewTaxInvoiceData.billEmail
                                                    }
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label
                                                  htmlFor=""
                                                  className="contact"
                                                >
                                                  Contact No:
                                                  <span>
                                                    {" "}
                                                    {
                                                      previewTaxInvoiceData.billContactNo
                                                    }
                                                  </span>
                                                </label>
                                              </div>
                                              {appSettings && appSettings?.isGSTApplicable && (
                                                <div>
                                                  <label
                                                    htmlFor=""
                                                    className="gst-no"
                                                  >
                                                    GST:{" "}
                                                    <span>
                                                      {
                                                        previewTaxInvoiceData.billGSTNo
                                                      }{" "}
                                                    </span>
                                                  </label>
                                                </div>)}
                                              {previewTaxInvoiceData.billState && (
                                                <div>
                                                  <label
                                                    htmlFor=""
                                                    className="gst-no"
                                                  >
                                                    State :{" "}
                                                    <span>
                                                      {
                                                        previewTaxInvoiceData.billState
                                                      }{" "}
                                                    </span>
                                                  </label>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          {previewTaxInvoiceData?.shipCustName && (
                                            <div className=" right p-0">
                                              <div className="name">
                                                <label
                                                  htmlFor=""
                                                  id="small-heading"
                                                >
                                                  Ship To,{" "}
                                                </label>

                                                <br />
                                              </div>
                                              <div className="address">
                                                <div>
                                                  <label htmlFor="">
                                                    {
                                                      previewTaxInvoiceData.shipCustName
                                                    }
                                                  </label>
                                                </div>
                                                <div>
                                                  <label
                                                    htmlFor=""
                                                    id="address"
                                                  >
                                                    {
                                                      previewTaxInvoiceData.shipAddr
                                                    }
                                                  </label>
                                                </div>
                                                <div>
                                                  <label
                                                    htmlFor=""
                                                    className="contact"
                                                  >
                                                    Contact No:
                                                    <span>
                                                      {" "}
                                                      {
                                                        previewTaxInvoiceData.shipContactNo
                                                      }
                                                    </span>
                                                  </label>
                                                </div>
                                                {appSettings && appSettings?.isGSTApplicable && (
                                                  <div>
                                                    <label
                                                      htmlFor=""
                                                      className="gst-no"
                                                    >
                                                      GST:{" "}
                                                      <span>
                                                        {
                                                          previewTaxInvoiceData.shipGSTNo
                                                        }{" "}
                                                      </span>
                                                    </label>
                                                  </div>)}
                                              </div>
                                            </div>
                                          )}
                                        </td>
                                      </tr>
                                    </table>
                                  </div>
                                </div>
                              </div>

                              <div
                                className="detail-table-main"
                                id="modal-in-tab"
                                style={{ marginTop: "-4px" }}
                              >
                                <table
                                  style={{
                                    borderTop: "0.765311px solid #111111",
                                    borderBottom: "0.765311px solid #111111",
                                    width: "100%",
                                  }}
                                >
                                  <thead>
                                    <tr className="heading-row">
                                      <td style={{ paddingLeft: "10px" }}>#</td>
                                      <td>Product Name/Service Name</td>
                                      <td>HSN/SAC</td>
                                      <td>Quantity</td>
                                      <td>Rate</td>
                                      <td>Unit</td>
                                      <td>Discount</td>
                                      <td
                                      // style={{ width: "20%" }}
                                      >
                                        Amount
                                      </td>
                                      {appSettings && appSettings?.isGSTApplicable && (
                                        isStateSame) ? (
                                        <>
                                          <td colSpan="2">CGST</td>
                                          <td colSpan="2">SGST</td>
                                        </>
                                      ) : (
                                        <>
                                          {appSettings && appSettings?.isGSTApplicable && (
                                            <td colSpan="2">IGST</td>
                                          )}
                                        </>

                                      )}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {previewTaxInvoiceData.invoiceDetails &&
                                      previewTaxInvoiceData.invoiceDetails
                                        .length > 0 &&
                                      previewTaxInvoiceData.invoiceDetails.map(
                                        (invDetails, index) => {
                                          let unit =
                                            units &&
                                            units.filter((item) => {
                                              return (
                                                item.id === invDetails.unitId
                                              );
                                            })[0]?.unit;

                                          return (
                                            <tr key={invDetails.id}>
                                              <td
                                                style={{
                                                  paddingTop: "2px",
                                                  paddingBottom: "2px",
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                {index + 1}
                                              </td>
                                              <td
                                                style={{ padding: "2px 4px" }}
                                              >
                                                {invDetails.productName}
                                              </td>
                                              <td
                                                style={{ padding: "2px 4px" }}
                                              >
                                                {invDetails.hsnCode}
                                              </td>
                                              <td
                                                style={{ padding: "2px 4px" }}
                                              >
                                                {invDetails.qty}
                                              </td>
                                              <td
                                                style={{ padding: "2px 4px" }}
                                              >
                                                {invDetails.rate}
                                              </td>
                                              <td
                                                style={{ padding: "2px 4px" }}
                                              >
                                                {invDetails.unit}
                                              </td>
                                              <td
                                                style={{ padding: "2px 4px" }}
                                              >
                                                {invDetails.discPer}{" "}
                                                {appSettings?.discType ===
                                                  "Amount"
                                                  ? ""
                                                  : "%"}
                                              </td>
                                              <td
                                                style={{ padding: "2px 4px" }}
                                              >
                                                {invDetails.discAmount}
                                              </td>
                                              {appSettings && appSettings.isGSTApplicable &&
                                                (isStateSame) ? (
                                                <>
                                                  <td
                                                    style={{
                                                      padding: "2px 4px",
                                                    }}
                                                  >
                                                    {invDetails.cgst}%
                                                  </td>
                                                  <td
                                                    style={{
                                                      padding: "2px 4px",
                                                    }}
                                                  >
                                                    {invDetails.cgstAmount}
                                                  </td>
                                                  <td
                                                    style={{
                                                      padding: "2px 4px",
                                                    }}
                                                  >
                                                    {invDetails.sgst}%
                                                  </td>
                                                  <td
                                                    style={{
                                                      padding: "2px 4px",
                                                    }}
                                                  >
                                                    {invDetails.sgstAmount}
                                                  </td>
                                                </>
                                              ) : (
                                                <>
                                                  {appSettings && appSettings.isGSTApplicable && (
                                                    <td
                                                      style={{
                                                        padding: "2px 4px",
                                                      }}
                                                    >
                                                      {invDetails.igst}%
                                                    </td>)}
                                                  {appSettings && appSettings.isGSTApplicable && (
                                                    <td
                                                      style={{
                                                        padding: "2px 4px",
                                                      }}
                                                    >
                                                      {invDetails.igstAmount}
                                                    </td>)}
                                                </>
                                              )}
                                            </tr>
                                          );
                                        }
                                      )}
                                  </tbody>
                                </table>
                              </div>

                              <div
                                className="sub-total-section"
                                style={{ marginTop: "-20px  " }}
                              >
                                <div className="bank-details">
                                  {previewTaxInvoiceData?.bankDetails && (
                                    <label htmlFor="">Bank Details :</label>
                                  )}
                                  {previewTaxInvoiceData?.bankDetails &&
                                    previewTaxInvoiceData?.bankDetails
                                      .split("\r\n")
                                      .map((str, i) => {
                                        return (
                                          <div
                                            key={i + "bankDetails"}
                                            className="bank-sub"
                                          >
                                            <label htmlFor="">
                                              {str && str}
                                            </label>
                                          </div>
                                        );
                                      })}
                                </div>
                                <div className="right-section">
                                  <div className="left">
                                    <div className="text-sub">
                                      <label htmlFor="">Sub Total</label>
                                    </div>
                                    {appSettings && appSettings.isGSTApplicable &&
                                      (isStateSame) ? (
                                      <>
                                        <div className="text-sub">
                                          <label htmlFor="">CGST</label>
                                        </div>
                                        <div className="text-sub">
                                          <label htmlFor="">SGST</label>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        {appSettings && appSettings.isGSTApplicable && (
                                          <div className="text-sub">
                                            <label htmlFor="">IGST</label>
                                          </div>)}
                                      </>
                                    )}
                                    {appSettings && appSettings?.isRoundOff && (
                                      <div className="text-sub">
                                        <label htmlFor="">Round off</label>
                                      </div>
                                    )}
                                  </div>
                                  <div className="right">
                                    <div className="sub-total">
                                      <label htmlFor="">
                                        ₹ {previewTaxInvoiceData.subTotal}
                                      </label>
                                    </div>
                                    {appSettings && appSettings.isGSTApplicable &&
                                      (isStateSame) ? (
                                      <>
                                        <div className="sub-total">
                                          <label htmlFor="">
                                            ₹ {previewTaxInvoiceData.cgstAmount}
                                          </label>
                                        </div>
                                        <div className="sub-total">
                                          <label htmlFor="">
                                            ₹ {previewTaxInvoiceData.sgstAmount}
                                          </label>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        {appsetting && appSettings.isGSTApplicable && (
                                          <div className="sub-total">
                                            <label htmlFor="">
                                              ₹ {previewTaxInvoiceData.igstAmount}
                                            </label>
                                          </div>)}
                                      </>
                                    )}
                                    {appSettings && appSettings?.isRoundOff && (
                                      <div className="sub-total">
                                        <label htmlFor="">
                                          Rs.{" "}
                                          {previewTaxInvoiceData.roundOff.toFixed(
                                            2
                                          ) || "0.00"}
                                        </label>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div
                                className="mainsub-total"
                                style={{
                                  borderBottom:
                                    "0.765311px solid rgba(35, 33, 34, 0.5) ",
                                }}
                              ></div>
                              <div className="total-amt-main">
                                <div
                                  className="total-amount-section"
                                  id="sub-total-section"
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      marginRight: "150px",
                                      alignItems: "left",
                                      fontSize: "12px"
                                    }}
                                  >
                                    <label htmlFor=""> <b>Payments Terms : </b>
                                    </label>
                                    <label htmlFor="">
                                      &nbsp;
                                      {previewTaxInvoiceData?.paymentTerms}
                                    </label>
                                  </div>
                                  <div className="left">
                                    <div className="text-sub">
                                      <label htmlFor="">Total Amount</label>
                                    </div>
                                  </div>
                                  <div className="right">
                                    <div className="sub-total">
                                      <label htmlFor="">
                                        ₹{" "}
                                        {commaNumber(
                                          Math.round(
                                            previewTaxInvoiceData.totalAmount
                                          ).toFixed(2)
                                        )}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div className="in-word">
                                  <label htmlFor="">{amountInWords}</label>
                                </div>
                              </div>
                              <div
                                className="line-total"
                                style={{
                                  borderBottom: "0.765311px solid #111111 ",
                                  borderRadius: "3.82655px",
                                }}
                              ></div>
                              <div className="disc-sign-main ">
                                <table style={{ width: "100%" }}>
                                  <tr>
                                    {/* <td
                                      valign="top"
                                      style={{ paddingRight: "20px" }}
                                    >
                                      <div className=" left ">
                                        <div
                                          className="description"
                                          style={{
                                            borderRadius: "5px",
                                          }}
                                        >
                                          <textarea
                                            className="form-control"
                                            id="exampleFormControlTextarea1"
                                            rows="3"
                                            placeholder="Declaration"
                                          ></textarea>
                                        </div>
                                      </div>
                                    </td> */}

                                    <td>
                                      <div className="terms_service">
                                        <p className="main-title">
                                          Terms of Services :
                                        </p>
                                        <div className="term-conditions">
                                          {logo?.terms ? logo.terms : ""}
                                        </div>
                                      </div>
                                    </td>

                                    {/* <td
                                      valign="top"
                                      style={{ paddingRight: "20px", width : "312px" }}
                                    >
                                      <div className="left">
                                        <div
                                          className="Terms-of-Services"
                                          style={{
                                            border: "0.765311px solid #111111 ",
                                            padding: "7px",
                                            borderRadius: "5px",
                                          }}
                                        >
                                          <div
                                            className="heading-TS"
                                            style={{ fontSize: "11px" }}
                                          >
                                            <label
                                              htmlFor=""
                                              style={{ fontWeight: "600" }}
                                            >
                                              Terms of Services :
                                            </label>
                                          </div>

                                          <div className="term-conditions">
                                            {logo?.terms ? logo.terms : ""}
                                          </div>

                                        </div>
                                      </div>
                                    </td> */}

                                    <td valign="top">
                                      <div className="right">
                                        <div
                                          className="upload"
                                          style={{
                                            border: "0.765311px solid #111111 ",
                                            textAlign: "center",
                                            borderRadius: "5px",
                                            padding: "10px",
                                          }}
                                        >
                                          {Dark === "lightMode" ? (
                                            <img
                                              src={
                                                logo?.signtureLogo
                                                  ? logo?.signtureLogo
                                                  : ""
                                              }
                                              alt=""
                                            />
                                          ) : (
                                            <img
                                              src={
                                                logo?.signtureLogo
                                                  ? logo?.signtureLogo
                                                  : ""
                                              }
                                              alt=""
                                            />
                                          )}{" "}
                                          <br />
                                          <label
                                            htmlFor=""
                                            className="text-auth"
                                            style={{
                                              fontSize: "11px",
                                            }}
                                          >
                                            Authorized Signature
                                          </label>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </Modal.Body>
                </Modal>

                {/* =================== PRINT MODAL END ============================ */}
              </div>

              {/* ======== RIGHT SECTION ============ */}
              <div
                className="col-lg-4 right-section my-2"
                style={{ display: hideBothSide?.displayBlock }}
              >
                <div className="cx-search-wrapper">
                  {Dark === "lightMode" ? (
                    <>
                      <img src={ic_search} alt="" className="search-img" />
                      <img src={ic_bars_dot} alt="" className="bars-img" />
                    </>
                  ) : (
                    <>
                      <img src={ic_search_dark} alt="" className="search-img" />
                      <img src={ic_bars_dot_dark} alt="" className="bars-img" />
                    </>
                  )}
                  <input
                    type="text"
                    className="form-control"
                    placeholder={appSettings.isGSTApplicable ? "Enter GST No to Search" : "Enter customer name to search"}
                    value={upperCase}
                    onChange={(e) => {
                      setUpperCase(e.target.value.toUpperCase());
                      handleInvoiceSearch(e);
                    }}
                    maxLength="18"
                  />
                </div>
                {loading ? (
                  <Loader />
                ) : (
                  <div className="card-right-main">
                    <Tab.Container id="left-tabs-example" defaultActiveKey="">
                      <Nav variant="pills" className="flex-column">
                        {customerInvoices && customerInvoices.length > 0 ? (
                          <React.Fragment>
                            {customerInvoices.map((invoice, index) => {
                              return (
                                <Nav.Item
                                  key={"invoice" + index}
                                  onClick={() => {
                                    getInvoiceData(invoice.invoiceId);
                                    setSelectedListInvoiceId(invoice.invoiceId);
                                    setIsView(true);
                                    setHideCopy(false);
                                    setJpegCheck(false);
                                    setpdfCheck(false);
                                    setPrintButton(true);
                                  }}
                                >
                                <Nav.Link eventKey={"invoice" + index} className="p-0 border-bottom">
  {/* 'inner' ko d-flex banaya aur 'w-100' diya taaki poori width le */}
  <div className="inner d-flex justify-content-between align-items-center w-100 p-2" style={{ gap: '15px' }}>
    
    {/* LEFT SECTION: 'min-width: 0' sabse important hai overlap rokne ke liye */}
    <div className="left flex-grow-1" style={{ minWidth: 0 }}>
      <div className="cus-name">
        <label style={{ 
          display: 'block', 
          width: '100%', 
          whiteSpace: 'nowrap', 
          overflow: 'hidden', 
          textOverflow: 'ellipsis', // Lamba naam hone par '...' dikhayega
          fontWeight: 'bold',
          marginBottom: '2px'
        }}>
          {invoice.customerName}
        </label>
      </div>
      
      <div className="inn-no-date d-flex align-items-center gap-1" style={{ fontSize: '13px', color: '#666' }}>
        <label className="inn m-0" style={{ whiteSpace: 'nowrap' }}>{invoice.invoiceNo}</label>
        <span className="line mx-1" style={{ borderLeft: '1px solid #ddd', height: '12px' }}></span>
        <label className="date m-0" style={{ whiteSpace: 'nowrap' }}>
          {displayDateFormat(appSettings.dateFormat, invoice.invoiceDate)}
        </label>
      </div>
    </div>

    {/* RIGHT SECTION: 'flex-shrink: 0' taaki Amount hamesha poora dikhe aur dabe nahi */}
    <div className="right text-end" style={{ flexShrink: 0, minWidth: 'fit-content' }}>
      <div className="amt fw-bold text-primary">
        <label className="m-0">
          Rs. {commaNumber(invoice.invoiceAmount)}
        </label>
      </div>
      <div className="status" style={{ fontSize: '11px' }}>
        <label className="m-0 badge bg-light text-dark border">
          {invoice.invoiceStatus}
        </label>
      </div>
    </div>

  </div>
</Nav.Link>
                                </Nav.Item>
                              );
                            })}
                          </React.Fragment>
                        ) : (
                          // <p className="mt-5 m-auto text-danger">
                          //   No Records Found{" "}
                          // </p>
                          <p className="mt-5 m-auto txt-no-record">
                            No Records to Show{" "}
                          </p>
                        )}
                      </Nav>
                    </Tab.Container>
                  </div>
                )}
              </div>
            </div>
          </section>

          <Modal
            className="sales-view-modal"
            size="lg"
            show={isView1}
            onHide={() => setIsView1(false)}
            aria-labelledby="example-modal-sizes-title-lg"
          >
            <Modal.Body>
              <div className="btnCloseRper">
                <div>
                  <Link
                    to="#"
                    className="text-white"
                    onClick={() => setIsView1(false)}
                  >
                    <img src={Axe} alt="" className="closeBtn" />
                  </Link>
                </div>
                <div>
                  <Link to="#" className="salesCopyBtn text-white rpsCopyBtn">
                    Copy
                  </Link>
                </div>
              </div>
              <div className="main-invoice-card">
                <div className="invoice-inner-main">
                  <div className="text-invoice-main">
                    <div className="text-invoice-inner">
                      <div className="left">
                        <div className="text-invoice-heading">
                          {/* <label htmlFor="">Tax Invoice</label> */}
                        </div>
                        <div className="invoice-date-number">
                          <label htmlFor="">#AS00001</label>
                          <label htmlFor="">
                            Date: <span>20-12-2021</span>
                          </label>
                          <label htmlFor="">
                            Due Date:<span>20-12-2021</span>
                          </label>
                        </div>
                      </div>
                      {/* <div className="right">
                            <img src={Logo} alt="" />
                          </div> */}
                    </div>
                  </div>
                  <div className="name-details-main">
                    <div className="name-details-inner row">
                      <div className="col-lg-7 left p-0">
                        <div className="name">
                          <label htmlFor="">Ashish Sharma</label>
                          <Link to="#">
                            {/* <img src={ic_green_pen} alt="" /> */}
                          </Link>
                        </div>
                        <div className="address">
                          <div>
                            <label htmlFor="" id="address">
                              236/B-Block, <br /> Vishal Market, Vasantkunj{" "}
                              <br /> New Delhi, India
                            </label>
                          </div>
                          <div>
                            <label htmlFor="" className="contact">
                              Contact No:
                              <span> +91 0000000000</span>
                            </label>
                          </div>
                          <div>
                            <label htmlFor="" className="gst-no">
                              GST No. : <span> 0XXXXXXXXXXXXX</span>
                            </label>
                          </div>
                          <div>
                            <label htmlFor="" className="pan-no">
                              PAN No. :<span>PXXXXXXXX</span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-5 right p-0">
                        <div className="place-heading">
                          <label htmlFor="">Place of Supply:</label>
                          <Link to="#">
                            {/* <img src={ic_green_pen} alt="" /> */}
                          </Link>
                        </div>
                        <div className="place">
                          <label htmlFor="">Maharashtra-27</label>
                        </div>
                        <div className="place-heading">
                          <label htmlFor="">Mode of Payment:</label>
                          <Link to="#">
                            {/* <img src={ic_green_pen} alt="" /> */}
                          </Link>
                        </div>
                        <div className="place">
                          <label htmlFor="">Cash/Cheque.</label> <br />
                          <label htmlFor="">
                            Cheque No. <span>XXX06542</span>
                          </label>
                          <br />
                          <label htmlFor="">Bank of Maharashtra</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="name-details-main" id="info">
                    <div className="name-details-inner row">
                      <div className="col-lg-7 left p-0">
                        <div className="name">
                          <label htmlFor="" id="small-heading">
                            Bill To,
                          </label>
                          <Link to="#">
                            {/* <img src={ic_green_pen} alt="" /> */}
                          </Link>{" "}
                          <br />
                        </div>
                        <div className="address">
                          <div>
                            <label htmlFor="">Vikram Aditya</label>
                          </div>
                          <div>
                            <label htmlFor="" id="address">
                              H. No. 6-AB, <br /> Bistol tower, Azad Nagar{" "}
                              <br /> New Delhi, India
                            </label>
                          </div>
                          <div>
                            <label htmlFor="" className="contact">
                              Contact No:
                              <span> +91 0000000000</span>
                            </label>
                          </div>
                          <div>
                            <label htmlFor="" className="gst-no">
                              GST: <span>0XXXXXXXXXXXXX (Optional)</span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-5 right p-0">
                        <div className="name">
                          <label htmlFor="" id="small-heading">
                            Ship To,{" "}
                          </label>
                          <Link to="#">
                            {/* <img src={ic_green_pen} alt="" /> */}
                          </Link>
                          <br />
                        </div>
                        <div className="address">
                          <div>
                            <label htmlFor="">Vikram Aditya</label>
                          </div>
                          <div>
                            <label htmlFor="" id="address">
                              H. No. 6-AB, <br /> Bistol tower, Azad Nagar{" "}
                              <br /> New Delhi, India
                            </label>
                          </div>
                          <div>
                            <label htmlFor="" className="contact">
                              Contact No:
                              <span> +91 0000000000</span>
                            </label>
                          </div>
                          <div>
                            <label htmlFor="" className="gst-no">
                              GST: <span>0XXXXXXXXXXXXX (Optional)</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="detail-table-main" id="modal-in-tab">
                    <table>
                      <thead>
                        <tr className="heading-row">
                          <td>#</td>
                          <td>Product Name/Service Name</td>
                          <td>HSN/SAC</td>
                          <td>Quantity</td>
                          <td>Rate</td>
                          <td colSpan="2">CGST</td>
                          <td colSpan="2">SGST</td>
                          <td>Amount</td>
                        </tr>
                      </thead>
                      <tbody>
                        <td>1</td>
                        <td>Ui/UX Design for mobile</td>
                        <td>986662</td>
                        <td>10</td>
                        <td>₹ 10,000</td>
                        <td>9%</td>
                        <td>₹ 1800</td>
                        <td>9%</td>
                        <td>₹ 1800</td>
                        <td>₹ 11,800</td>
                      </tbody>
                    </table>
                  </div>
                  <div className="total-amt-main">
                    <div className="sub-total-section" id="sub-total-section">
                      <div className="left">
                        <div className="text-sub">
                          <label htmlFor="">Total Amount</label>
                        </div>
                      </div>
                      <div className="right">
                        <div className="sub-total">
                          <label htmlFor="">₹ 11,800</label>
                        </div>
                      </div>
                    </div>
                    <div className="in-word">
                      <label htmlFor="">
                        Eleven thousand eight hundred rupees only
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </main>
    </>
  );
};

export default SalesServices;
